window.ThoughtSpotAnalyticsAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.ThoughtSpotAccessManagerServer);
    var customerAnalyticsTiers = {};


    self.getCustomerAnalyticsTiers = function (brandId) {
        var deferred = $q.defer();

        if (customerAnalyticsTiers[brandId]) {
            deferred.resolve(customerAnalyticsTiers[brandId])
        } else {
            _protected.request("brands/" + brandId + "/customer_analytics_tiers", 'GET')
                .then(function (result) {
                    if (result && result.data && result.data.data && result.status == 200) {
                        customerAnalyticsTiers[brandId] = result.data.data;
                        deferred.resolve(result.data.data);
                    }
                }).catch(function (err) {
                deferred.reject(err);
            });
        }
        return deferred.promise;
    };

    self.getAnalyticsUser = function (brandId, userId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/analytics_user_activation/" + userId, 'GET')
            .then(function (result) {
                if (result && result.data && result.status == 200) {
                    var response = result.data.data || {};
                    deferred.resolve(response);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getTSUserToken = function (brandId, userId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/user_analytics_barri/ts_user_auth_token/" + userId, 'GET')
            .then(function (result) {
                if (result && result.data && result.status == 200) {
                    deferred.resolve(result.data.token);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getUserPrivileges = function (brandId, userId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/user_analytics_barri/privileges/" + userId, 'GET')
            .then(function (result) {
                if (result && result.data && result.status == 200) {
                    var response = result.data.data || {};
                    deferred.resolve(response);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getCustomerAclGroups = function (brandId, types) {
        var deferred = $q.defer();
        var params = {
            group_types: types
        };
        _protected.request("brands/" + brandId + "/customer_acl_groups", 'GET', params)
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getCustomerAccessLevels = function (brandId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/customer_access_level", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getCustomerWorksheets = function (brandId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/customer_worksheets", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getCustomerFiscalCalendars = function (brandId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/customer_fiscal_calendars", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.activateUserAnalytics = function (brandId, userDetails) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/analytics_user_activation", 'POST', userDetails)
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result.data);
                }
            })
            .catch(function (err) {
                deferred.reject(err.data);
            });

        return deferred.promise;
    };

    self.editUserAnalytics = function (brandId, userId, userDetails) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/analytics_user_activation/" + userId, 'PUT', userDetails)
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result.data);
                }
            })
            .catch(function (err) {
                deferred.reject(err.data);
            });

        return deferred.promise;
    };


});


ThoughtSpotAnalyticsAPI.ACL_GROUP_TYPES = {
    DATA_ACCESS: 'DATA_ACCESS',
    CONTENT_ACCESS: 'CONTENT_ACCESS',
    PRIVILEGES: 'PRIVILEGES'
};